import Vue from 'vue'
import VueRouter from 'vue-router'
import Meeting from '../views/Meeting.vue'
// import MeetingGrid from '../views/MeetingGrid.vue'
import JoinMeeting from '../views/JoinMeeting.vue'
import Admin from '../views/Admin.vue'
import Invitation from '../views/Invitation.vue'
import Register from '../views/Register.vue'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Meeting',
    // component: JoinMeeting
    component: Meeting
  }, 
  // {
  //   path: '/grid',
  //   name: 'Grid',
  //   component: MeetingGrid
  // }, 
  {
    path: '/register',
    name: 'Register',
    component: Register
  }, {
    path: '/admin/:tab?/:id?',
    name: 'Admin',
    component: Admin,
    // props: true
  }, {
    path: '/settings',
    name: 'Admin',
    component: Admin
  }, {
    path: '/invitation/:id',
    name: 'Invitation',
    component: Invitation
  }, {
    path: '/:role',
    name: 'Meeting',
    component: Meeting
  // }, {
  //   path: '/:id',
  //   name: 'Meeting',
  //   component: Meeting
  // }, {
  //   path: '/:id/:command',
  //   name: 'Meeting',
  //   component: Meeting
  }
]

const router = new VueRouter({
  routes
})

export default router
